module.exports = __webpack_public_path__ + "static/media/img3.fa7f5e76.jpeg";